import React from 'react';
import styles from './Contato.module.css';

export default function Contato () {
    return (
        <h1>Aqui você encontra nossa pagina de contato!!!</h1>
    )
}